import style from "../inputText/Input.module.css";

function TextArea(props){


    return (
        <div>
            <textarea
                className={props.errorClause? style.errorBorder:style.txtInput}
                placeholder={props.placeholder}
                id={props.id}
                value={props.value}
                onChange={props.onChange}
                disabled={props.disabled}
                style={props.style}
                rows={props.rows}
                cols={props.cols}
            />
            <div>
                {props.errorClause?<label className={style.errorMessage} htmlFor={props.id}>{props.errorMessage}</label>:null}
            </div>
        </div>

    )


}
export default TextArea